import React, { useContext, useEffect, useState } from "react";
import {
  ActivityForm,
  CoursesForm,
  HobbiesForm,
  InternshipForm,
  LanguageForm,
  ReferencesForm,
} from "../..";
import { Heading } from "../../../components";
import { ResumeContext } from "../../../contexts/resumeContext";
import ProjectForm from "../ProjectForm/ProjectForm";
import styles from "./MiscForm.module.css";

const sectionList = [
  {
    label: "Courses",
    value: "courses",
    description: "Highlight any extra courses that makes you stand apart",
  },
  {
    label: "Extra-curricular Activities",
    value: "activities",
    description:
      "Add activities apart from academics to showcase your strenghts",
  },
  {
    label: "Internships",
    value: "internships",
    description: "Crisp report of your past interships",
  },
  {
    label: "Projects",
    value: "projects",
    description: "Showcase your personal projects",
  },
  {
    label: "Hobbies",
    value: "hobbies",
    description: "Present the other side of your personality",
  },
  {
    label: "Languages",
    value: "languages",
    description: "Bi-lungual, or multi-lungual? Add it in a jiffy",
  },
  // {
  //   label: "References",
  //   value: "references",
  //   description: "Providing valuable references helps you put ahead of line.",
  // },

];

function MiscForm() {
  const { resumeInfo } = useContext(ResumeContext);

  const [miscSections, setMiscSections] = useState(
    Object.keys(resumeInfo?.misc || {}) || []
  );
  const sectionMap = {
    courses: <CoursesForm />,
    activities: <ActivityForm />,
    internships: <InternshipForm />,
    projects: <ProjectForm />,
    hobbies: <HobbiesForm />,
    languages: <LanguageForm />,
    references: <ReferencesForm />,

  };

  useEffect(() => {
    const userFormEl = document.querySelector(".userForm");
    userFormEl?.scrollTo({
      top: userFormEl?.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  }, [miscSections.length]);

  const addSection = (section) => {
    let miscSectionsArr = [...miscSections];
    miscSectionsArr = [...miscSectionsArr, section];
    setMiscSections(miscSectionsArr);
  };

  return (
    <div>
      <Heading
        content="Add Section"
        subheading="Curated list of section to help you put your best foot forward"
      />
      <div>
        {sectionList.map((section) => (
          <button
            key={section.label}
            className={styles.sectionButton}
            disabled={miscSections.includes(section.value)}
            onClick={() => addSection(section.value)}
          >
            {section.label}
            <p>{section.description}</p>
          </button>
        ))}
      </div>
      {miscSections.map((section) => (
        <div key={`section_${section}`} className={styles.sectionWrapper}>
          {sectionMap[section]}
        </div>
      ))}
    </div>
  );
}

export default MiscForm;
